import React, { useState } from 'react';
import BuildingsLoader from '../loaders/BuildingsLoader';
import DataAlertsLoader from '../loaders/DataAlertsLoader';
import AlertsTable from './AlertsTable';
import AlertStats from './AlertStats';
import { AlertCreator } from './AlertRow';

import './data-alerts.css';

const DataAlerts = () => {
  const [creating, setCreating] = useState(false);
  return (
    <div style={{ display: 'grid' }}>
      <DataAlertsLoader />
      <BuildingsLoader />
      <AlertStats setCreatingAlert={setCreating} />
      {creating ? <AlertCreator setCreating={setCreating} /> : null}
      <AlertsTable />
    </div>
  );
};

export default DataAlerts;
